var exports = {
  "wx": "InboxMessageHeader.module__header___RGVxN3",
  "LD": "InboxMessageHeader.module__headerLeft___RGVxN3",
  "$s": "InboxMessageHeader.module__headerActions___RGVxN3",
  "FW": "InboxMessageHeader.module__headerIconButton___RGVxN3",
  "nr": "InboxMessageHeader.module__headerIcon___RGVxN3",
};

module.exports = exports;
